export enum Layouts {
    STRAIGHT_RUN = 'straight-run',
    L_SHAPED = 'l-shaped',
    GALLEY = 'galley',
    U_SHAPED = 'u-shaped',
    L_SHAPED_ISLAND = 'l-shaped-island',
    U_SHAPED_ISLAND = 'u-shaped-island'
}
